import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { TechModule } from '@schir-int-client/tech';
import { VorlageFacade, VorlageSharedModule } from '@schir-int-client/vorlage-shared';
import { AddVorlageDialogComponent } from './add-vorlage-dialog/add-vorlage-dialog.component';
import { VorlageFileUploadComponent } from './vorlage-file-upload/vorlage-file-upload.component';
import { VorlageListComponent } from './vorlage-list/vorlage-list.component';
import { VorlageUploadComponent } from './vorlage-upload/vorlage-upload.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
	imports: [
		CommonModule,
		TechModule,
		VorlageSharedModule,
		MatTableModule,
		MatGridListModule,
		MatButtonModule,
		MatInputModule,
		MatFormFieldModule,
		MatDialogModule,
		MatIconModule,
		FormsModule,
		ReactiveFormsModule,
		MatTooltipModule,
	],
	declarations: [VorlageListComponent, VorlageUploadComponent, VorlageFileUploadComponent, AddVorlageDialogComponent],
	exports: [VorlageListComponent, VorlageUploadComponent, VorlageFileUploadComponent],
	providers: [VorlageFacade],
})
export class VorlageModule {}
